import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
// import { SmallButton } from "../../UIkit";
import "../../../assets/css/profileBox.css";
import GuestImage from "../../../assets/img/src/no-profile.png";

const ProfileBox = (props) => {
  const [user, setUser] = useState({});
  const uid = props.uid;
  const createUserData = () => {
    db.collection("users")
      .doc(uid)
      .get()
      .then((doc) => {
        const userData = doc.data();
        // console.log(userData);
        setUser(userData);
      });
  };
  useEffect(() => {
    createUserData();
    //uidが渡された瞬間に1回だけ起動
    // eslint-disable-next-line
  }, [uid]);
  return (
    <div className="profile--container">
      {user && (
        <div className="common-section-containerflex-column">
          <div className="plofile-text__headline text-white ">作家情報</div>
          <div className="spacer-box--s" />
          <div className="flex-row">
            {typeof user.avatar !== "undefined" ? (
              <img className="avatar-trim--profile text-white " src={user.avatar} alt="アバター画像" width="80" />
            ) : (
              <img className="avatar-trim" src={GuestImage} alt="アバター画像" width="80" />
            )}
            <div className="row-spacer--l"></div>
            <div>
              <div className="plofile-text__basic text-white ">{props.organizerName}</div>
              <div className="spacer-box--s" />
              <div className="plofile-text__basic text-white ">{user.genre}</div>
            </div>
            {/* <div className="flex-row--justright">
              <SmallButton label="フォロー" />
              <div className="spacer-box--ss" />
              <div className="plofile-text__follow center">Follow</div>
              <div className="spacer-box--sss" />
              <div className="plofile-text__headline center">123人</div>
            </div> */}
          </div>
          <div className="spacer-box--s" />
          <div className="plofile-text__intro text-white ">{user.intro}</div>
        </div>
      )}
    </div>
  );
};

export default ProfileBox;
